import { render, staticRenderFns } from "./studentPopuper.vue?vue&type=template&id=70c1952a&scoped=true&"
import script from "./studentPopuper.vue?vue&type=script&lang=js&"
export * from "./studentPopuper.vue?vue&type=script&lang=js&"
import style0 from "./studentPopuper.vue?vue&type=style&index=0&id=70c1952a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1952a",
  null
  
)

export default component.exports